import {Field, Formik, FormikHelpers as FormikActions} from 'formik';
import {default as React} from 'react';
import {Button} from '~/components/Button';
import {Form, FormColumn, FormControls, FormRow, FormTitle, InputField, IntentText, TextareaField, EditorField} from '~/components/Form';
import {IModalComponent, IModalComponentClose} from '~/components/Modal';
import {Intent} from '~/lib/intent';
import {ISupplyPackage, SupplyPackageSchema} from '~/modules/Pmp/models/SupplyPackage';
import AvailableAttributes from '~/modules/Bidders/components/AvailableAttributes';

interface ISupplyPackageForm {
    supplyPackage?: ISupplyPackage;
    onSubmit?: (values: ISupplyPackage, formikActions: FormikActions<ISupplyPackage>, close: IModalComponentClose) => void;
}

export const SupplyPackageForm: IModalComponent<ISupplyPackageForm> = (props) => <Formik initialValues={props.supplyPackage}
    validationSchema={SupplyPackageSchema}
    onSubmit={(supplyPackage, actions) => props.onSubmit(supplyPackage, actions, props.close)}
>
    {({values: supplyPackage, status, isSubmitting}) => <Form>
        <FormTitle>{supplyPackage.id ? 'Edit Supply Package' : 'Create Supply Package'}</FormTitle>
        {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
        <FormRow>
            <FormColumn>
                <Field name='name'
                    options={{
                        placeholder: 'SupplyPackage name',
                        disabled: isSubmitting
                    }}
                    label='Name'
                    component={InputField}
                />
                <Field name='description'
                    label='Description'
                    options={{
                        placeholder: 'Description',
                        disabled: isSubmitting
                    }}
                    component={TextareaField}
                />
                <Field name='rules'
                    label='Rules'
                    options={{
                        disabled: isSubmitting,
                        canFullScreen: true,
                        mode: 'javascript',
                        minLines: 4,
                        maxLines: 20
                    }}
                    component={EditorField}
                />
                <AvailableAttributes />
            </FormColumn>
        </FormRow>
        <FormControls>
            <Button disabled={isSubmitting}
                onClick={props.close}
            >Cancel</Button>
            <Button type='submit'
                disabled={isSubmitting}
                intent={Intent.PRIMARY}
                rightIcon={isSubmitting && <i className='fa fa-spinner fa-spin'/>}
            >Save</Button>
        </FormControls>
    </Form>}
</Formik>;
